<template>
  <div>
    <div class="item">
      <select v-model="commandType" @change="addCommand">
        <option value="" disabled selected>Välj ett kommando att lägga till...</option>
        <option value="node">Kontrollera en enhet</option>
        <option value="push">Skicka en notis</option>
        <option value="delay">Fördröjning mellan kommando</option>
        <option value="bridge">Bridge-kommando</option>
      </select>
    </div>

    <table>
      <tbody>
        <tr class="nohover" v-for="(command, i) in commands">
          <!-- Status på en enhet -->
          <td v-if="command.type === 'RunNodeMethodCmd'">

            <!-- Noden -->
            <div class="item">
              <select v-model.number="command.cmd.targetNode">
                <option value="" disabled selected>Välj en enhet</option>
                <option v-for="node in getNodesWithSetCapability" v-if="node.name" :value="node.id">{{ node.name }}</option>
              </select>
            </div>

            <!-- Capability -->
            <div class="item" v-if="command.cmd.targetNode">
              <select v-model="command.cmd.cap">
                <option value="" disabled selected>Välj typ</option>
                <option v-for="cap in $root.data.nodes.find(node => node.id === command.cmd.targetNode).capabilities" v-if="cap in $root.capabilities && $root.capabilities[cap].set" :value="cap">{{ $root.capabilities[cap].name }}</option>
              </select>
            </div>
            
            <!-- Kommando (på, av, etc) -->
            <div class="item" v-if="command.cmd.cap">
              <div v-if="$root.capabilities[command.cmd.cap].type === 'number'">
                <select v-model.number="command.cmd.arguments[0]" @change="command.cmd.method = 'setValue'">
                  <option value="" disabled selected>Välj ett värde</option>
                  <option v-for="n in 101" :value="(n - 1) / 100">{{ n - 1 }}{{ $root.capabilities[command.cmd.cap].unit }}</option>
                </select>
              </div>
              <div v-if="$root.capabilities[command.cmd.cap].type === 'boolean'">
                <select v-model="command.cmd.method">
                  <option value="" disabled selected>Välj händelse</option>
                  <option v-for="(value, key) in $root.capabilities[command.cmd.cap].values" :value="value.method">{{ $root.capabilities[command.cmd.cap].values[key].name }}</option>
                </select>
              </div>
              
            </div>
          </td>
          
          <!-- Push-notis -->
          <td v-if="command.type === 'SendPushCmd'">
            <!-- Klienten -->
            <div class="item">
              <select v-model="command.deviceIds" multiple style="height:150px;">
                <option value="" disabled selected>Välj en klient</option>
                <option v-for="client in clients" :value="client.id">{{ client.deviceName }}</option>
              </select>
            </div>

            <!-- Meddelande -->
            <div class="item" v-if="command.deviceIds.length">
              <input type="text" v-model="command.message" placeholder="Meddelande till enheten">
            </div>
          </td>   
          
          <td v-if="command.type === 'DelayCmd'">
            <div class="item">
              <input type="number" step="100" min="0" max="30000" v-model.number="command.durationMs">
              <div class="descr">Ovanstående anges i millisekunder vilket betyder att du får ta antal sekunder du vill fördröja och multiplicera med 1000. 5 sekunder är alltså 5000 ms.</div>
            </div>
          </td>
          
          <td v-if="command.type === 'BridgeCmd'">
            <div class="item">
              <select v-model="command.action">
                <option value="" disabled selected>Välj ett kommando</option>
                <option value="restart">Starta om Bridge</option>
              </select>
            </div>

          </td>
          
          <td align="right" widht="20" @click="remove(i)"><img src="../../assets/delete2.png" width="22"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { HTTP } from '../../http.js'
  
  export default {
    name: 'testLite',
    props: ['commands'],
    data () {
      return {
        commandType: '',
        clients: [],
        setCapabilities: []
      }
    },
    created () {
      // Hämta alla capabilities där det är möjligt
      // att sätta värden.
      for (const cap in this.$root.capabilities) {
        const capability = this.$root.capabilities[cap]
        capability.set && this.setCapabilities.push(cap)
      }

      // Hämta klienterna som finns registrerad i Bridgen
      HTTP.get('clients')
      .then(res => res.data)
      .then(json => this.clients = json)
    },
    methods: {
      addCommand () {
        if (this.commandType === 'node') {
          this.commands.push({
            type: 'RunNodeMethodCmd',
            delay: 0,
            cmd: {
              cap: '',
              arguments: [],
              targetNode: 0,
              method: 'setValue'
            }
          })
        } else if (this.commandType === 'push') {
          this.commands.push({
            type: 'SendPushCmd',
            message: '',
            sound: 'default',
            deviceIds: [],
            badge: 1,
            delay: 0
          })
        } else if (this.commandType === 'delay') {
          this.commands.push({
            type: 'DelayCmd',
            durationMs: 0
          })
        } else if (this.commandType === 'bridge') {
          this.commands.push({
            type: 'BridgeCmd',
            action: ''
          })
        }
        
        this.commandType = ''
      },
      
      remove (i) {
        this.commands.splice(i, 1)
      }
    },
    computed: {
      getNodesWithSetCapability () {
        return this.$root.data.nodes.filter(node => {
          return node.capabilities.some(v => this.setCapabilities.includes(v))
        })
      }
    },
    destroyed () {}
  }
</script>


<style scoped>
  .item {
    margin-bottom:0px;
    padding-bottom:7px;
  }
  
  .descr {
    padding-top:5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/commandsView.vue